module.exports = __webpack_public_path__ + "images/external_images/svg/icons/014-shared folder.svg";